// extracted by mini-css-extract-plugin
export default {"container":"AdminPage_container__EQkn1","tabsContainer":"AdminPage_tabsContainer__q0Ist","tab":"AdminPage_tab__A-KY0"};